<template>
  <el-dialog
    :title="$t('productPriceRule.add')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <el-form :model="addProductPriceRuleInfo" label-width="120px">
      <el-form-item :label="$t('productPriceRule.strategyName')" required>
        <el-input
          v-model="addProductPriceRuleInfo.ruleName"
          :placeholder="$t('productPriceRule.requiredRuleName')"
          style="width: 100%">
        </el-input>
      </el-form-item>
      
      <el-form-item :label="$t('productPriceRule.strategyType')" required>
        <el-select
          v-model="addProductPriceRuleInfo.ruleType"
          :placeholder="$t('productPriceRule.requiredRuleType')"
          style="width: 100%">
          <el-option disabled value="">{{$t('productPriceRule.requiredRuleType')}}</el-option>
          <el-option value="1001">{{$t('productPriceRule.normal')}}</el-option>
          <el-option value="2002">{{$t('productPriceRule.supplyChain')}}</el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('productPriceRule.sellingPrice')" required>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select
              v-model="addProductPriceRuleInfo.priceBase"
              :placeholder="$t('common.requiredSelect')"
              style="width: 100%">
              <el-option disabled value="">{{$t('common.requiredSelect')}}</el-option>
              <el-option value="1">{{$t('productPriceRule.costPrice')}}</el-option>
              <el-option 
                v-if="addProductPriceRuleInfo.ruleType === '2002'"
                value="2">{{$t('productPriceRule.sellingPrice')}}</el-option>
              <el-option 
                v-if="addProductPriceRuleInfo.ruleType === '2002'"
                value="3">{{$t('productPriceRule.marketPrice')}}</el-option>
              <el-option 
                v-if="addProductPriceRuleInfo.ruleType === '2002'"
                value="4">{{$t('productPriceRule.ownerPrice')}}</el-option>
              <el-option 
                v-if="addProductPriceRuleInfo.ruleType === '2002'"
                value="5">{{$t('productPriceRule.memberPrice')}}</el-option>
            </el-select>
          </el-col>
          <el-col :span="14">
            <el-input
              v-model="addProductPriceRuleInfo.price"
              :placeholder="$t('productPriceRule.percentage')">
              <template slot="append">%</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- 市场价 -->
      <el-form-item :label="$t('productPriceRule.marketPrice')">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select
              v-model="addProductPriceRuleInfo.otPriceBase"
              :placeholder="$t('common.requiredSelect')"
              style="width: 100%">
              <el-option disabled value="">{{$t('common.requiredSelect')}}</el-option>
              <el-option value="1">{{$t('productPriceRule.costPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="2">{{$t('productPriceRule.sellingPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="3">{{$t('productPriceRule.marketPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="4">{{$t('productPriceRule.ownerPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="5">{{$t('productPriceRule.memberPrice')}}</el-option>
            </el-select>
          </el-col>
          <el-col :span="14">
            <el-input v-model="addProductPriceRuleInfo.otPrice" :placeholder="$t('productPriceRule.percentage')">
              <template slot="append">%</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- 会员价 -->
      <el-form-item :label="$t('productPriceRule.memberPrice')">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select
              v-model="addProductPriceRuleInfo.vipPriceBase"
              :placeholder="$t('common.requiredSelect')"
              style="width: 100%">
              <el-option disabled value="">{{$t('common.requiredSelect')}}</el-option>
              <el-option value="1">{{$t('productPriceRule.costPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="2">{{$t('productPriceRule.sellingPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="3">{{$t('productPriceRule.marketPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="4">{{$t('productPriceRule.ownerPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="5">{{$t('productPriceRule.memberPrice')}}</el-option>
            </el-select>
          </el-col>
          <el-col :span="14">
            <el-input v-model="addProductPriceRuleInfo.vipPrice" :placeholder="$t('productPriceRule.percentage')">
              <template slot="append">%</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- 业主价 -->
      <el-form-item :label="$t('productPriceRule.ownerPrice')">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select
              v-model="addProductPriceRuleInfo.ownerPriceBase"
              :placeholder="$t('common.requiredSelect')"
              style="width: 100%">
              <el-option disabled value="">{{$t('common.requiredSelect')}}</el-option>
              <el-option value="1">{{$t('productPriceRule.costPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="2">{{$t('productPriceRule.sellingPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="3">{{$t('productPriceRule.marketPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="4">{{$t('productPriceRule.ownerPrice')}}</el-option>
              <el-option v-if="addProductPriceRuleInfo.ruleType === '2002'" value="5">{{$t('productPriceRule.memberPrice')}}</el-option>
            </el-select>
          </el-col>
          <el-col :span="14">
            <el-input v-model="addProductPriceRuleInfo.ownerPrice" :placeholder="$t('productPriceRule.percentage')">
              <template slot="append">%</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- 物业抵扣金 -->
      <el-form-item :label="$t('productPriceRule.propertyDeduction')">
        <el-row :gutter="20">
          <el-col :span="20">
            <el-input v-model="addProductPriceRuleInfo.deduction" :placeholder="$t('productPriceRule.percentage')">
              <template slot="append">%</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>
      
      <el-form-item>
        <el-button type="primary" @click="saveProductPriceRuleInfo">
          {{$t('common.save')}}
        </el-button>
        <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { saveProductPriceRule } from '@/api/goods/productPriceRuleApi'

export default {
  name: 'AddProductPriceRule',
  data() {
    return {
      dialogVisible: false,
      addProductPriceRuleInfo: {
        ruleName: '',
        price: '',
        otPrice: '',
        vipPrice: '',
        ownerPrice: '',
        deduction: '',
        ruleType: '',
        priceBase: '1',
        otPriceBase: '1',
        vipPriceBase: '1',
        ownerPriceBase: '1',
        shopId: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.resetForm()
    },
    resetForm() {
      this.addProductPriceRuleInfo = {
        ruleName: '',
        price: '',
        otPrice: '',
        vipPrice: '',
        ownerPrice: '',
        deduction: '',
        ruleType: '',
        priceBase: '1',
        otPriceBase: '1',
        vipPriceBase: '1',
        ownerPriceBase: '1',
        shopId: ''
      }
    },
    saveProductPriceRuleInfo() {
      this.addProductPriceRuleInfo.shopId = getShopId()
      saveProductPriceRule(this.addProductPriceRuleInfo)
        .then(response => {
          this.$message.success(this.$t('common.saveSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        })
        .catch(error => {
          console.error('保存失败:', error)
        })
    }
  }
}
</script>